const fiscalYearEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/accounting/fiscal-years/` as const,
  detail: (companyId: string, fiscalYearId: number) =>
    `/companies/${companyId}/accounting/fiscal-years/${fiscalYearId}` as const
}

export default fiscalYearEndpoints
